import { Dispatch } from "redux";

import { ActionType, ToastMessage } from "./model";

const setToastStatus = (msg: ToastMessage[], messageId: string) => (dispatch: Dispatch) => {
  dispatch({
    type: ActionType.SET_TOAST,
    data: msg,
    messageId: messageId,
  });
};

export { setToastStatus };
